import api from "@/services/api";
import type {
	ChecklistTemplateDetail,
	ChecklistTemplateLookupApiResponse,
	ChecklistTemplateQueryParams,
	CreateChecklistResponse,
	CreateTemplatePayload,
	TemplatesPaginatedWithCountsResponse,
	UpdateChecklistPayload,
	UpdateChecklistResponse,
} from "../types";

export const checklistTemplateService = {
	async getTemplateById(id: number): Promise<ChecklistTemplateDetail> {
		const response = await api.get<ChecklistTemplateDetail>(
			`/api/checklisttemplate/${id}`
		);
		return response.data;
	},

	async getLookup(): Promise<ChecklistTemplateLookupApiResponse[]> {
		const response = await api.get<ChecklistTemplateLookupApiResponse[]>(
			"/api/checklisttemplate/lookup"
		);
		return response.data;
	},

	async createTemplate(
		payload: CreateTemplatePayload
	): Promise<CreateChecklistResponse> {
		const response = await api.post<CreateChecklistResponse>(
			"/api/checklisttemplate",
			payload
		);

		return response.data;
	},

	async updateTemplate(
		templateId: number,
		payload: UpdateChecklistPayload
	): Promise<UpdateChecklistResponse> {
		const response = await api.put<UpdateChecklistResponse>(
			`/api/checklisttemplate/${templateId}`,
			payload
		);

		return response.data;
	},

	async archiveTemplate(templateId: number): Promise<void> {
		await api.put(`/api/checklisttemplate/${templateId}/archive`);
	},

	async getChecklistTemplateAll(
		params: ChecklistTemplateQueryParams
	): Promise<TemplatesPaginatedWithCountsResponse> {
		const response = await api.get<TemplatesPaginatedWithCountsResponse>(
			"/api/checklisttemplate/paginated",
			{ params }
		);

		return response.data;
	},
};
